
export default "/assets/user-group-micro.40fee02e.svg"